export interface IMileageMultiRateInfo {
    mileageRateSetupId: number;
    rangeFrom: number;
    rangeTo: number;
    mileageRate: number;
    milesTravelled: number;
    amount: number;
    vatRate: any;
    vatRateName: string;
    vatRateId: any;
    isRangeToInvalid: boolean;
    orgVehicleTypeMapId: number;
    effectiveFrom: number;
    nrFuelRate: number;
    chargingType: number;
}


export class MileageMultiRateInfo implements IMileageMultiRateInfo {
    mileageRateSetupId: number;
    rangeFrom: number;
    rangeTo: number;
    mileageRate: number;
    milesTravelled: number;
    amount: number;
    vatRate: any;
    vatRateName: string;
    vatRateId: any;
    isRangeToInvalid: boolean;
    orgVehicleTypeMapId: number;
    effectiveFrom: number;
    nrFuelRate: number;
    chargingType: number;
    constructor() {
        this.mileageRateSetupId = 0;
        this.rangeFrom = 0;
        this.rangeTo = 10000;
        this.mileageRate = 0;
        this.milesTravelled = 0;
        this.amount = 0;

    }
}